// apps/api/src/qxcircle/qxcircle-hashtag.ts
// Description: QXCircle hashtag normalize · match · tag feed builder.
// Owner: Masa Bayu
// Date: 2026-08-24

import { BadRequestException } from "./_nestjs-common";
import type { QxCircleFeedPost, QxCircleTagFeedResponse } from "./qxcircle.types";

const TAG_PATTERN = /#([a-zA-Z0-9_]+)/g;

export function normalizeQxCircleTag(tagRaw: string): string {
  const trimmed = tagRaw.trim().replace(/^#+/, "");
  if (!trimmed || !/^[a-zA-Z0-9_]+$/.test(trimmed)) {
    throw new BadRequestException("Invalid hashtag");
  }
  return trimmed.toLowerCase();
}

export function extractQxCircleTags(body: string): string[] {
  const found = new Set<string>();
  for (const match of body.matchAll(TAG_PATTERN)) {
    const tag = match[1]?.toLowerCase();
    if (tag) found.add(tag);
  }
  return [...found];
}

export function postBodyHasTag(body: string, tag: string): boolean {
  return extractQxCircleTags(body).includes(tag.toLowerCase());
}

export function buildQxCircleTagFeed(
  tagRaw: string,
  posts: QxCircleFeedPost[],
  hiddenPostIds: Set<string>,
  blockedHandles: Set<string>,
  present: (post: QxCircleFeedPost) => QxCircleFeedPost,
): QxCircleTagFeedResponse {
  const tag = normalizeQxCircleTag(tagRaw);
  const items = posts
    .filter(
      (post) =>
        !hiddenPostIds.has(post.id) &&
        !blockedHandles.has(post.authorHandle) &&
        postBodyHasTag(post.body, tag),
    )
    .map((post) => present(post))
    .sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));
  return {
    world: "qxcircle",
    slice: "hashtag",
    tag,
    count: items.length,
    items,
  };
}
